<script setup lang="ts">
import {useEnums} from "@hantera/portal-app";


const props = defineProps<{
  tag: string
}>();

const enumFields = useEnums();

const value = enumFields.value('order', 'tags', props.tag)

</script>

<template>
  <div
    class="compact-tag"
    :class="{
      'has-hue': value?.hue,
    }"
    :style="value?.hue ? `--color-hue: ${value.hue}` : ''"
    :title="value?.label"
  >

  </div>
</template>

<style>
.compact-tag {
  margin: 0 2px;
  border-radius: 3px;
  padding: 0 4px;
  white-space: nowrap;
  width: 14px;
  height: 14px;

  display: flex;
  align-items: center;

  --color-lightness: var(--color-60-l);
  color: hsl(var(--color-text));
  background-color: hsl(var(--color-hue), var(--color-saturation), var(--color-lightness));
}

.compact-tag.has-hue {
  --color-saturation: 116.08%;
  --color-lightness: 36.74%;
  --color-text: 0, 100%, 100%;
}

</style>